<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_customVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_customVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_customVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesPrdProductionInfoResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_customVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_customVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_customVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"></em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author liang gang qiang
// Date 2021-10-20 16:35:51

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import customVuexNameMixin from "@/mixin/em/common/stuffs/customVuex/customVuexNameMixin";

export default {
    name: "mintalMesPrdProductionInfoListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, customVuexNameMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    data() {
        return {
            customVuexName: null
        }
    },
    mounted() {
        this.fromRouteParam();
        this.$nextTick(() => {
            if (this.$route.query.prdResultId) {
                this.insertHolder('prdResultId', this.$route.query.prdResultId);
            }
        })
    }
};
</script>